import { render, staticRenderFns } from "./FighterLayout.vue?vue&type=template&id=12faa2cd&lang=pug"
import script from "./FighterLayout.vue?vue&type=script&lang=js"
export * from "./FighterLayout.vue?vue&type=script&lang=js"
import style0 from "./FighterLayout.vue?vue&type=style&index=0&id=12faa2cd&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports